import { Box, Link, styled, Typography, typographyClasses } from '@mui/material';
import { getPlatformClient } from 'shared/utils/platform-utils';

type FooterInformation = {
  phoneNumber: string;
  client: string;
  termsOfUse: string;
  privacyStatement: string;
};

const SignInFooter = () => {
  return (
    <StyledContactWrapperBox>
      <StyledInfoText variant="body1">
        Door aan te melden ga je akkoord met de{' '}
        <StyledLink href={termsOfUse} target="_blank" rel="noreferrer">
          gebruiksvoorwaarden
        </StyledLink>{' '}
        en de{' '}
        <StyledLink href={privacyStatement} target="_blank" rel="noreferrer">
          privacyverklaring.
        </StyledLink>
      </StyledInfoText>
      <StyledContactText variant="body1" display="block">
        Neem contact op met {client} support
      </StyledContactText>
      <StyledContactText variant="body1" display="block">
        {phoneNumber} als je een probleem hebt tijdens het inloggen.
      </StyledContactText>
    </StyledContactWrapperBox>
  );
};

const footerInformationBasedOnClient: Record<
  ReturnType<typeof getPlatformClient>,
  FooterInformation
> = {
  LEVELWORKS: {
    phoneNumber: '085 2089605',
    client: 'Level.works',
    termsOfUse: 'https://nl.level.works/legal/gebruikersvoorwaarden-opdrachtgevers',
    privacyStatement: 'https://level.works/privacy-statement/',
  },
  AETHON: {
    phoneNumber: '088 0351525',
    client: 'Aelio',
    termsOfUse: 'https://aelio.nl/gebruikersvoorwaarden-opdrachtgevers/',
    privacyStatement: 'https://aelio.nl/privacy/',
  },
  HOLLANDWORX: {
    phoneNumber: '085 3037286',
    client: 'Hollandworx',
    termsOfUse: 'https://doc.hollandworx.nl/gebruikersvoorwaarden-opdrachtgever/',
    privacyStatement: 'https://doc.hollandworx.nl/privacy-statement/',
  },
};

const platformClient = getPlatformClient();
const { phoneNumber, termsOfUse, privacyStatement, client } =
  footerInformationBasedOnClient[platformClient];

const StyledContactWrapperBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(3),
}));

const StyledContactText = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    color: theme.palette.grey[500],
  },
}));

const StyledInfoText = styled(Typography)(({ theme }) => ({
  [`&.${typographyClasses.root}`]: {
    color: theme.palette.grey[500],
  },
  display: 'block',
  marginBottom: theme.spacing(8),
  marginTop: theme.spacing(2.5),
}));

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.grey[500],
  textDecorationColor: theme.palette.grey[500],
}));

export { SignInFooter };
